import { Link } from "@tanstack/react-router";
import { useChatStore } from "@/store/chat";

/** Retained bookmark for local testing; the actual app still starts at `/`. */
export function ChatPage() {
  const setOpen = useChatStore((state) => state.setOpen);
  return (
    <main className="mx-auto max-w-lg space-y-5 p-10">
      <h1 className="text-3xl">Your conversations go with you.</h1>
      <p>
        Open the floating Messages button from any page to continue the
        conversation.
      </p>
      {import.meta.env.VITE_WEBCHAT_ENABLED === "true" && (
        <button
          className="rounded border px-4 py-2"
          onClick={() => setOpen(true)}
        >
          Open messages
        </button>
      )}
      <p>
        <Link to="/" className="underline">
          Return to Secret Missions
        </Link>
      </p>
    </main>
  );
}
